import httpClient from "./httpClient";
const putStartJobWithId = (params) => httpClient.put(`/record/update-time/` , params)

const getStartJob = () => httpClient.get(`/record/time/auto/`)
    // ).then(
    // (res) => res.data)
    // .catch((e)=>{
    //     
    // })
const postLastTime = () => httpClient.get(`/record/time/last/`)

const postManualRecord = (params) => httpClient.post('/record/time/manual/',params)


const putContacts = (params, id) => httpClient.put(`/MainPage/ContactInf/Put/${id}` , {
    id: id ,
    informationNo: params.informationNo,
    customerServiceNo: params.customerServiceNo,
    email: params.email
})
const postLogin = (params) =>  httpClient.post('/account/login/', params)

const stopJobTime = (params) => httpClient.post('/record/time/auto/stop/', params)

const startJobTime = (params) => httpClient.get('/record/time/auto/', params)

export {
    postLastTime,
    getStartJob,
    putContacts,
    putStartJobWithId,
    postLogin,
    postManualRecord,
    stopJobTime,
    startJobTime
}
